import type { FC } from 'react';

export const BackIcon: FC<{
  color?: string;
}> = (props) => (
  <svg
    width="100%"
    height="100%"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 8.75L2.5 5L6.25 1.25"
      stroke={props.color || '#E6E6E9'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
